export default __webpack_public_path__ + "static/media/work_ec-top.b6173749.jpg";